export default __webpack_public_path__ + "static/media/pdf.0685f050.svg";